//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.17.0.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { ServiceProxyBase } from "./proxy-base";import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { DateTime, Duration } from "luxon";

export class AccountServiceProxy extends ServiceProxyBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterInput | undefined , cancelToken?: CancelToken | undefined): Promise<RegisterOutput> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRegister(_response));
        });
    }

    protected processRegister(response: AxiosResponse): Promise<RegisterOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RegisterOutput.fromJS(resultData200);
            return Promise.resolve<RegisterOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegisterOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendPasswordResetCode(body: SendPasswordResetCodeInput | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/Account/SendPasswordResetCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendPasswordResetCode(_response));
        });
    }

    protected processSendPasswordResetCode(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordInput | undefined , cancelToken?: CancelToken | undefined): Promise<ResetPasswordOutput> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/Account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processResetPassword(_response));
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<ResetPasswordOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResetPasswordOutput.fromJS(resultData200);
            return Promise.resolve<ResetPasswordOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResetPasswordOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendEmailActivationLink(body: SendEmailActivationLinkInput | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/Account/SendEmailActivationLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSendEmailActivationLink(_response));
        });
    }

    protected processSendEmailActivationLink(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activateEmail(body: ActivateEmailInput | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/Account/ActivateEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processActivateEmail(_response));
        });
    }

    protected processActivateEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AlarmsServiceProxy extends ServiceProxyBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEdit(body: CreateOrEditAlarmDto | undefined , cancelToken?: CancelToken | undefined): Promise<CreateOrEditAlarmOutput> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/Alarms/CreateOrEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateOrEdit(_response));
        });
    }

    protected processCreateOrEdit(response: AxiosResponse): Promise<CreateOrEditAlarmOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateOrEditAlarmOutput.fromJS(resultData200);
            return Promise.resolve<CreateOrEditAlarmOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateOrEditAlarmOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAll(body: GetAllAlarmsInput | undefined , cancelToken?: CancelToken | undefined): Promise<GetAllAlarmsOutput> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/Alarms/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<GetAllAlarmsOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllAlarmsOutput.fromJS(resultData200);
            return Promise.resolve<GetAllAlarmsOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllAlarmsOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAlarmForEdit(body: GetAlarmForEditInput | undefined , cancelToken?: CancelToken | undefined): Promise<GetAlarmForEditOutput> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/Alarms/GetAlarmForEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAlarmForEdit(_response));
        });
    }

    protected processGetAlarmForEdit(response: AxiosResponse): Promise<GetAlarmForEditOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAlarmForEditOutput.fromJS(resultData200);
            return Promise.resolve<GetAlarmForEditOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAlarmForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined, accountNo: number, platformCode: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/Alarms/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (accountNo === undefined || accountNo === null)
            throw new Error("The parameter 'accountNo' must be defined and cannot be null.");
        else
            url_ += "AccountNo=" + encodeURIComponent("" + accountNo) + "&";
        if (platformCode === undefined || platformCode === null)
            throw new Error("The parameter 'platformCode' must be defined and cannot be null.");
        else
            url_ += "PlatformCode=" + encodeURIComponent("" + platformCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ChartsServiceProxy extends ServiceProxyBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @param symbol (optional) 
     * @param resolution (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param countback (optional) 
     * @return Success
     */
    history(symbol: string | undefined, resolution: string | undefined, from: number | undefined, to: number | undefined, countback: number | undefined, accountNo: number, platformCode: string , cancelToken?: CancelToken | undefined): Promise<GetChartHistoryOutputDto> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/Charts/History?";
        if (symbol === null)
            throw new Error("The parameter 'symbol' cannot be null.");
        else if (symbol !== undefined)
            url_ += "Symbol=" + encodeURIComponent("" + symbol) + "&";
        if (resolution === null)
            throw new Error("The parameter 'resolution' cannot be null.");
        else if (resolution !== undefined)
            url_ += "Resolution=" + encodeURIComponent("" + resolution) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent("" + to) + "&";
        if (countback === null)
            throw new Error("The parameter 'countback' cannot be null.");
        else if (countback !== undefined)
            url_ += "Countback=" + encodeURIComponent("" + countback) + "&";
        if (accountNo === undefined || accountNo === null)
            throw new Error("The parameter 'accountNo' must be defined and cannot be null.");
        else
            url_ += "AccountNo=" + encodeURIComponent("" + accountNo) + "&";
        if (platformCode === undefined || platformCode === null)
            throw new Error("The parameter 'platformCode' must be defined and cannot be null.");
        else
            url_ += "PlatformCode=" + encodeURIComponent("" + platformCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processHistory(_response));
        });
    }

    protected processHistory(response: AxiosResponse): Promise<GetChartHistoryOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetChartHistoryOutputDto.fromJS(resultData200);
            return Promise.resolve<GetChartHistoryOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetChartHistoryOutputDto>(null as any);
    }

    /**
     * @param platformName (optional) 
     * @param platformDescription (optional) 
     * @return Success
     */
    config(platformName: string | undefined, platformDescription: string | undefined, accountNo: number, platformCode: string , cancelToken?: CancelToken | undefined): Promise<ChartConfigDto> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/Charts/Config?";
        if (platformName === null)
            throw new Error("The parameter 'platformName' cannot be null.");
        else if (platformName !== undefined)
            url_ += "PlatformName=" + encodeURIComponent("" + platformName) + "&";
        if (platformDescription === null)
            throw new Error("The parameter 'platformDescription' cannot be null.");
        else if (platformDescription !== undefined)
            url_ += "PlatformDescription=" + encodeURIComponent("" + platformDescription) + "&";
        if (accountNo === undefined || accountNo === null)
            throw new Error("The parameter 'accountNo' must be defined and cannot be null.");
        else
            url_ += "AccountNo=" + encodeURIComponent("" + accountNo) + "&";
        if (platformCode === undefined || platformCode === null)
            throw new Error("The parameter 'platformCode' must be defined and cannot be null.");
        else
            url_ += "PlatformCode=" + encodeURIComponent("" + platformCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processConfig(_response));
        });
    }

    protected processConfig(response: AxiosResponse): Promise<ChartConfigDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChartConfigDto.fromJS(resultData200);
            return Promise.resolve<ChartConfigDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChartConfigDto>(null as any);
    }

    /**
     * @return Success
     */
    time(accountNo: number, platformCode: string, cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/Charts/Time?";
        if (accountNo === undefined || accountNo === null)
            throw new Error("The parameter 'accountNo' must be defined and cannot be null.");
        else
            url_ += "AccountNo=" + encodeURIComponent("" + accountNo) + "&";
        if (platformCode === undefined || platformCode === null)
            throw new Error("The parameter 'platformCode' must be defined and cannot be null.");
        else
            url_ += "PlatformCode=" + encodeURIComponent("" + platformCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processTime(_response));
        });
    }

    protected processTime(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return Success
     */
    symbols(symbol: string, accountNo: number, platformCode: string , cancelToken?: CancelToken | undefined): Promise<ChartSymbolDto> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/Charts/Symbols?";
        if (symbol === undefined || symbol === null)
            throw new Error("The parameter 'symbol' must be defined and cannot be null.");
        else
            url_ += "Symbol=" + encodeURIComponent("" + symbol) + "&";
        if (accountNo === undefined || accountNo === null)
            throw new Error("The parameter 'accountNo' must be defined and cannot be null.");
        else
            url_ += "AccountNo=" + encodeURIComponent("" + accountNo) + "&";
        if (platformCode === undefined || platformCode === null)
            throw new Error("The parameter 'platformCode' must be defined and cannot be null.");
        else
            url_ += "PlatformCode=" + encodeURIComponent("" + platformCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processSymbols(_response));
        });
    }

    protected processSymbols(response: AxiosResponse): Promise<ChartSymbolDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChartSymbolDto.fromJS(resultData200);
            return Promise.resolve<ChartSymbolDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChartSymbolDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditChartTemplate(body: CreateOrEditChartTemplateInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<CreateOrEditChartTemplateOutputDto> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/Charts/CreateOrEditChartTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateOrEditChartTemplate(_response));
        });
    }

    protected processCreateOrEditChartTemplate(response: AxiosResponse): Promise<CreateOrEditChartTemplateOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateOrEditChartTemplateOutputDto.fromJS(resultData200);
            return Promise.resolve<CreateOrEditChartTemplateOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateOrEditChartTemplateOutputDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getChartTemplate(body: GetChartTemplateInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<GetChartTemplateOutputDto> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/Charts/GetChartTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetChartTemplate(_response));
        });
    }

    protected processGetChartTemplate(response: AxiosResponse): Promise<GetChartTemplateOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetChartTemplateOutputDto.fromJS(resultData200);
            return Promise.resolve<GetChartTemplateOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetChartTemplateOutputDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteChartTemplate(body: DeleteChartTemplateInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<DeleteChartTemplateOutputDto> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/Charts/DeleteChartTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteChartTemplate(_response));
        });
    }

    protected processDeleteChartTemplate(response: AxiosResponse): Promise<DeleteChartTemplateOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteChartTemplateOutputDto.fromJS(resultData200);
            return Promise.resolve<DeleteChartTemplateOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteChartTemplateOutputDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllChartTemplates(body: InputBaseDto | undefined , cancelToken?: CancelToken | undefined): Promise<GetAllChartTemplatesOutput> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/Charts/GetAllChartTemplates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllChartTemplates(_response));
        });
    }

    protected processGetAllChartTemplates(response: AxiosResponse): Promise<GetAllChartTemplatesOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllChartTemplatesOutput.fromJS(resultData200);
            return Promise.resolve<GetAllChartTemplatesOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllChartTemplatesOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrEditStudyTemplate(body: CreateOrEditStudyTemplateInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<CreateOrEditStudyTemplateOutputDto> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/Charts/CreateOrEditStudyTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateOrEditStudyTemplate(_response));
        });
    }

    protected processCreateOrEditStudyTemplate(response: AxiosResponse): Promise<CreateOrEditStudyTemplateOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateOrEditStudyTemplateOutputDto.fromJS(resultData200);
            return Promise.resolve<CreateOrEditStudyTemplateOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateOrEditStudyTemplateOutputDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getStudyTemplate(body: GetStudyTemplateInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<GetStudyTemplateOutputDto> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/Charts/GetStudyTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetStudyTemplate(_response));
        });
    }

    protected processGetStudyTemplate(response: AxiosResponse): Promise<GetStudyTemplateOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetStudyTemplateOutputDto.fromJS(resultData200);
            return Promise.resolve<GetStudyTemplateOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetStudyTemplateOutputDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteStudyTemplate(body: DeleteStudyTemplateInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<DeleteStudyTemplateOutputDto> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/Charts/DeleteStudyTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDeleteStudyTemplate(_response));
        });
    }

    protected processDeleteStudyTemplate(response: AxiosResponse): Promise<DeleteStudyTemplateOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteStudyTemplateOutputDto.fromJS(resultData200);
            return Promise.resolve<DeleteStudyTemplateOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteStudyTemplateOutputDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAllStudyTemplates(body: InputBaseDto | undefined , cancelToken?: CancelToken | undefined): Promise<GetAllStudyTemplatesOutput> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/Charts/GetAllStudyTemplates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetAllStudyTemplates(_response));
        });
    }

    protected processGetAllStudyTemplates(response: AxiosResponse): Promise<GetAllStudyTemplatesOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllStudyTemplatesOutput.fromJS(resultData200);
            return Promise.resolve<GetAllStudyTemplatesOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllStudyTemplatesOutput>(null as any);
    }
}

export class OrdersServiceProxy extends ServiceProxyBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateOrderInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<CreateOrderOutputDto> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/Orders/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreate(_response));
        });
    }

    protected processCreate(response: AxiosResponse): Promise<CreateOrderOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateOrderOutputDto.fromJS(resultData200);
            return Promise.resolve<CreateOrderOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateOrderOutputDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    modify(body: ModifyOrderInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<ModifyOrderOutputDto> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/Orders/Modify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processModify(_response));
        });
    }

    protected processModify(response: AxiosResponse): Promise<ModifyOrderOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ModifyOrderOutputDto.fromJS(resultData200);
            return Promise.resolve<ModifyOrderOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModifyOrderOutputDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getOrderHistory(body: GetOrderHistoryInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<GetOrderHistoryOutputDto> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/Orders/GetOrderHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetOrderHistory(_response));
        });
    }

    protected processGetOrderHistory(response: AxiosResponse): Promise<GetOrderHistoryOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetOrderHistoryOutputDto.fromJS(resultData200);
            return Promise.resolve<GetOrderHistoryOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOrderHistoryOutputDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    delete(body: DeleteOrderInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<DeleteOrderOutputDto> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/Orders/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processDelete(_response));
        });
    }

    protected processDelete(response: AxiosResponse): Promise<DeleteOrderOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteOrderOutputDto.fromJS(resultData200);
            return Promise.resolve<DeleteOrderOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteOrderOutputDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    close(body: CloseOrderInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<CloseOrderOutputDto> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/Orders/Close";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processClose(_response));
        });
    }

    protected processClose(response: AxiosResponse): Promise<CloseOrderOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CloseOrderOutputDto.fromJS(resultData200);
            return Promise.resolve<CloseOrderOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CloseOrderOutputDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    closeAllOrders(body: CloseAllOrdersInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<CloseAllOrdersOutputDto> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/Orders/CloseAllOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCloseAllOrders(_response));
        });
    }

    protected processCloseAllOrders(response: AxiosResponse): Promise<CloseAllOrdersOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CloseAllOrdersOutputDto.fromJS(resultData200);
            return Promise.resolve<CloseAllOrdersOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CloseAllOrdersOutputDto>(null as any);
    }
}

export class ProfileServiceProxy extends ServiceProxyBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordInput | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/Profile/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processChangePassword(_response));
        });
    }

    protected processChangePassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/Profile/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processChangeLanguage(_response));
        });
    }

    protected processChangeLanguage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SessionServiceProxy extends ServiceProxyBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(  cancelToken?: CancelToken | undefined): Promise<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetCurrentLoginInformations(_response));
        });
    }

    protected processGetCurrentLoginInformations(response: AxiosResponse): Promise<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return Promise.resolve<GetCurrentLoginInformationsOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCurrentLoginInformationsOutput>(null as any);
    }

    /**
     * @return Success
     */
    updateUserSignInToken(  cancelToken?: CancelToken | undefined): Promise<UpdateUserSignInTokenOutput> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/Session/UpdateUserSignInToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processUpdateUserSignInToken(_response));
        });
    }

    protected processUpdateUserSignInToken(response: AxiosResponse): Promise<UpdateUserSignInTokenOutput> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateUserSignInTokenOutput.fromJS(resultData200);
            return Promise.resolve<UpdateUserSignInTokenOutput>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateUserSignInTokenOutput>(null as any);
    }
}

export class TokenAuthServiceProxy extends ServiceProxyBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined , cancelToken?: CancelToken | undefined): Promise<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/v2.0/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processAuthenticate(_response));
        });
    }

    protected processAuthenticate(response: AxiosResponse): Promise<AuthenticateResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return Promise.resolve<AuthenticateResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticateResultModel>(null as any);
    }

    /**
     * @param refreshToken (optional) 
     * @return Success
     */
    refreshToken(refreshToken: string | undefined , cancelToken?: CancelToken | undefined): Promise<RefreshTokenResult> {
        let url_ = this.baseUrl + "/api/v2.0/TokenAuth/RefreshToken?";
        if (refreshToken === null)
            throw new Error("The parameter 'refreshToken' cannot be null.");
        else if (refreshToken !== undefined)
            url_ += "refreshToken=" + encodeURIComponent("" + refreshToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processRefreshToken(_response));
        });
    }

    protected processRefreshToken(response: AxiosResponse): Promise<RefreshTokenResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RefreshTokenResult.fromJS(resultData200);
            return Promise.resolve<RefreshTokenResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RefreshTokenResult>(null as any);
    }

    /**
     * @return Success
     */
    logOut(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2.0/TokenAuth/LogOut";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processLogOut(_response));
        });
    }

    protected processLogOut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TradeMasterServiceProxy extends ServiceProxyBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @return Success
     */
    getTradingAccountInfo(accountNo: number, platformCode: string , cancelToken?: CancelToken | undefined): Promise<GetTradingAccountInfoOutputDto> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/TradeMaster/GetTradingAccountInfo?";
        if (accountNo === undefined || accountNo === null)
            throw new Error("The parameter 'accountNo' must be defined and cannot be null.");
        else
            url_ += "AccountNo=" + encodeURIComponent("" + accountNo) + "&";
        if (platformCode === undefined || platformCode === null)
            throw new Error("The parameter 'platformCode' must be defined and cannot be null.");
        else
            url_ += "PlatformCode=" + encodeURIComponent("" + platformCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGetTradingAccountInfo(_response));
        });
    }

    protected processGetTradingAccountInfo(response: AxiosResponse): Promise<GetTradingAccountInfoOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTradingAccountInfoOutputDto.fromJS(resultData200);
            return Promise.resolve<GetTradingAccountInfoOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTradingAccountInfoOutputDto>(null as any);
    }
}

export class TradingAccountsServiceProxy extends ServiceProxyBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTradingAccount(body: CreateTradingAccountInputDto | undefined , cancelToken?: CancelToken | undefined): Promise<CreateTradingAccountOutputDto> {
        let url_ = this.baseUrl + "/api/v2.0/services/app/TradingAccounts/CreateTradingAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processCreateTradingAccount(_response));
        });
    }

    protected processCreateTradingAccount(response: AxiosResponse): Promise<CreateTradingAccountOutputDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateTradingAccountOutputDto.fromJS(resultData200);
            return Promise.resolve<CreateTradingAccountOutputDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateTradingAccountOutputDto>(null as any);
    }
}

export class ActivateEmailInput implements IActivateEmailInput {
    userId!: number;
    confirmationCode!: string | undefined;
    c!: string | undefined;

    constructor(data?: IActivateEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.confirmationCode = _data["confirmationCode"];
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ActivateEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["confirmationCode"] = this.confirmationCode;
        data["c"] = this.c;
        return data;
    }
}

export interface IActivateEmailInput {
    userId: number;
    confirmationCode: string | undefined;
    c: string | undefined;
}

export enum AlarmCondition {
    BidGreatorThen = 0,
    BidLessThen = 1,
    AskGreaterThen = 2,
    AskLessThen = 3,
}

export class AlarmDto implements IAlarmDto {
    alarmName!: string | undefined;
    price!: number;
    expiration!: DateTime | undefined;
    maxIterations!: number;
    condition!: AlarmCondition;
    tradingAccount!: string | undefined;
    symbol!: string | undefined;
    description!: string | undefined;
    id!: string;

    constructor(data?: IAlarmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alarmName = _data["alarmName"];
            this.price = _data["price"];
            this.expiration = _data["expiration"] ? DateTime.fromISO(_data["expiration"].toString()) : <any>undefined;
            this.maxIterations = _data["maxIterations"];
            this.condition = _data["condition"];
            this.tradingAccount = _data["tradingAccount"];
            this.symbol = _data["symbol"];
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AlarmDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlarmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alarmName"] = this.alarmName;
        data["price"] = this.price;
        data["expiration"] = this.expiration ? this.expiration.toString() : <any>undefined;
        data["maxIterations"] = this.maxIterations;
        data["condition"] = this.condition;
        data["tradingAccount"] = this.tradingAccount;
        data["symbol"] = this.symbol;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }
}

export interface IAlarmDto {
    alarmName: string | undefined;
    price: number;
    expiration: DateTime | undefined;
    maxIterations: number;
    condition: AlarmCondition;
    tradingAccount: string | undefined;
    symbol: string | undefined;
    description: string | undefined;
    id: string;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version!: string | undefined;
    releaseDate!: DateTime;
    currency!: string | undefined;
    currencySign!: string | undefined;
    allowTenantsToChangeEmailSettings!: boolean;
    userDelegationIsEnabled!: boolean;
    twoFactorCodeExpireSeconds!: number;
    features!: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? DateTime.fromISO(_data["releaseDate"].toString()) : <any>undefined;
            this.currency = _data["currency"];
            this.currencySign = _data["currencySign"];
            this.allowTenantsToChangeEmailSettings = _data["allowTenantsToChangeEmailSettings"];
            this.userDelegationIsEnabled = _data["userDelegationIsEnabled"];
            this.twoFactorCodeExpireSeconds = _data["twoFactorCodeExpireSeconds"];
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)![key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toString() : <any>undefined;
        data["currency"] = this.currency;
        data["currencySign"] = this.currencySign;
        data["allowTenantsToChangeEmailSettings"] = this.allowTenantsToChangeEmailSettings;
        data["userDelegationIsEnabled"] = this.userDelegationIsEnabled;
        data["twoFactorCodeExpireSeconds"] = this.twoFactorCodeExpireSeconds;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = (<any>this.features)[key];
            }
        }
        return data;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: DateTime;
    currency: string | undefined;
    currencySign: string | undefined;
    allowTenantsToChangeEmailSettings: boolean;
    userDelegationIsEnabled: boolean;
    twoFactorCodeExpireSeconds: number;
    features: { [key: string]: boolean; } | undefined;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress!: string;
    password!: string;
    twoFactorVerificationCode!: string | undefined;
    rememberClient!: boolean;
    twoFactorRememberClientToken!: string | undefined;
    singleSignIn!: boolean | undefined;
    returnUrl!: string | undefined;
    captchaResponse!: string | undefined;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.twoFactorVerificationCode = _data["twoFactorVerificationCode"];
            this.rememberClient = _data["rememberClient"];
            this.twoFactorRememberClientToken = _data["twoFactorRememberClientToken"];
            this.singleSignIn = _data["singleSignIn"];
            this.returnUrl = _data["returnUrl"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["twoFactorVerificationCode"] = this.twoFactorVerificationCode;
        data["rememberClient"] = this.rememberClient;
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["singleSignIn"] = this.singleSignIn;
        data["returnUrl"] = this.returnUrl;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    twoFactorVerificationCode: string | undefined;
    rememberClient: boolean;
    twoFactorRememberClientToken: string | undefined;
    singleSignIn: boolean | undefined;
    returnUrl: string | undefined;
    captchaResponse: string | undefined;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    shouldResetPassword!: boolean;
    passwordResetCode!: string | undefined;
    userId!: number;
    requiresTwoFactorVerification!: boolean;
    twoFactorAuthProviders!: string[] | undefined;
    twoFactorRememberClientToken!: string | undefined;
    returnUrl!: string | undefined;
    refreshToken!: string | undefined;
    refreshTokenExpireInSeconds!: number;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.shouldResetPassword = _data["shouldResetPassword"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.userId = _data["userId"];
            this.requiresTwoFactorVerification = _data["requiresTwoFactorVerification"];
            if (Array.isArray(_data["twoFactorAuthProviders"])) {
                this.twoFactorAuthProviders = [] as any;
                for (let item of _data["twoFactorAuthProviders"])
                    this.twoFactorAuthProviders!.push(item);
            }
            this.twoFactorRememberClientToken = _data["twoFactorRememberClientToken"];
            this.returnUrl = _data["returnUrl"];
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpireInSeconds = _data["refreshTokenExpireInSeconds"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["shouldResetPassword"] = this.shouldResetPassword;
        data["passwordResetCode"] = this.passwordResetCode;
        data["userId"] = this.userId;
        data["requiresTwoFactorVerification"] = this.requiresTwoFactorVerification;
        if (Array.isArray(this.twoFactorAuthProviders)) {
            data["twoFactorAuthProviders"] = [];
            for (let item of this.twoFactorAuthProviders)
                data["twoFactorAuthProviders"].push(item);
        }
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["returnUrl"] = this.returnUrl;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpireInSeconds"] = this.refreshTokenExpireInSeconds;
        return data;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    shouldResetPassword: boolean;
    passwordResetCode: string | undefined;
    userId: number;
    requiresTwoFactorVerification: boolean;
    twoFactorAuthProviders: string[] | undefined;
    twoFactorRememberClientToken: string | undefined;
    returnUrl: string | undefined;
    refreshToken: string | undefined;
    refreshTokenExpireInSeconds: number;
}

export class BrokerSummaryDto implements IBrokerSummaryDto {
    name!: string | undefined;
    tradingPlatforms!: TradingPlatformDto[] | undefined;

    constructor(data?: IBrokerSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["tradingPlatforms"])) {
                this.tradingPlatforms = [] as any;
                for (let item of _data["tradingPlatforms"])
                    this.tradingPlatforms!.push(TradingPlatformDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BrokerSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new BrokerSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.tradingPlatforms)) {
            data["tradingPlatforms"] = [];
            for (let item of this.tradingPlatforms)
                data["tradingPlatforms"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBrokerSummaryDto {
    name: string | undefined;
    tradingPlatforms: TradingPlatformDto[] | undefined;
}

export class ChangePasswordInput implements IChangePasswordInput {
    currentPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordInput {
    currentPassword: string;
    newPassword: string;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName!: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class ChartConfigDto implements IChartConfigDto {
    supports_search!: boolean;
    supports_group_request!: boolean;
    supports_marks!: boolean;
    supports_timescale_marks!: boolean;
    supports_time!: boolean;
    exchanges!: ChartExchangeDto[] | undefined;
    symbols_types!: ChartSymbolsTypeDto[] | undefined;
    supported_resolutions!: string[] | undefined;

    constructor(data?: IChartConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supports_search = _data["supports_search"];
            this.supports_group_request = _data["supports_group_request"];
            this.supports_marks = _data["supports_marks"];
            this.supports_timescale_marks = _data["supports_timescale_marks"];
            this.supports_time = _data["supports_time"];
            if (Array.isArray(_data["exchanges"])) {
                this.exchanges = [] as any;
                for (let item of _data["exchanges"])
                    this.exchanges!.push(ChartExchangeDto.fromJS(item));
            }
            if (Array.isArray(_data["symbols_types"])) {
                this.symbols_types = [] as any;
                for (let item of _data["symbols_types"])
                    this.symbols_types!.push(ChartSymbolsTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["supported_resolutions"])) {
                this.supported_resolutions = [] as any;
                for (let item of _data["supported_resolutions"])
                    this.supported_resolutions!.push(item);
            }
        }
    }

    static fromJS(data: any): ChartConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChartConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supports_search"] = this.supports_search;
        data["supports_group_request"] = this.supports_group_request;
        data["supports_marks"] = this.supports_marks;
        data["supports_timescale_marks"] = this.supports_timescale_marks;
        data["supports_time"] = this.supports_time;
        if (Array.isArray(this.exchanges)) {
            data["exchanges"] = [];
            for (let item of this.exchanges)
                data["exchanges"].push(item.toJSON());
        }
        if (Array.isArray(this.symbols_types)) {
            data["symbols_types"] = [];
            for (let item of this.symbols_types)
                data["symbols_types"].push(item.toJSON());
        }
        if (Array.isArray(this.supported_resolutions)) {
            data["supported_resolutions"] = [];
            for (let item of this.supported_resolutions)
                data["supported_resolutions"].push(item);
        }
        return data;
    }
}

export interface IChartConfigDto {
    supports_search: boolean;
    supports_group_request: boolean;
    supports_marks: boolean;
    supports_timescale_marks: boolean;
    supports_time: boolean;
    exchanges: ChartExchangeDto[] | undefined;
    symbols_types: ChartSymbolsTypeDto[] | undefined;
    supported_resolutions: string[] | undefined;
}

export class ChartExchangeDto implements IChartExchangeDto {
    value!: string | undefined;
    name!: string | undefined;
    desc!: string | undefined;

    constructor(data?: IChartExchangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.name = _data["name"];
            this.desc = _data["desc"];
        }
    }

    static fromJS(data: any): ChartExchangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChartExchangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["name"] = this.name;
        data["desc"] = this.desc;
        return data;
    }
}

export interface IChartExchangeDto {
    value: string | undefined;
    name: string | undefined;
    desc: string | undefined;
}

export class ChartHistoryDto implements IChartHistoryDto {
    time!: number;
    open!: number;
    high!: number;
    low!: number;
    close!: number;
    volume!: number;

    constructor(data?: IChartHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.time = _data["time"];
            this.open = _data["open"];
            this.high = _data["high"];
            this.low = _data["low"];
            this.close = _data["close"];
            this.volume = _data["volume"];
        }
    }

    static fromJS(data: any): ChartHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChartHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["time"] = this.time;
        data["open"] = this.open;
        data["high"] = this.high;
        data["low"] = this.low;
        data["close"] = this.close;
        data["volume"] = this.volume;
        return data;
    }
}

export interface IChartHistoryDto {
    time: number;
    open: number;
    high: number;
    low: number;
    close: number;
    volume: number;
}

export class ChartSymbolDto implements IChartSymbolDto {
    name!: string | undefined;
    exchangetraded!: string | undefined;
    exchangelisted!: string | undefined;
    timezone!: string | undefined;
    minmov!: number;
    minmov2!: number;
    pointvalue!: number;
    session!: string | undefined;
    has_intraday!: boolean;
    has_no_volume!: boolean;
    description!: string | undefined;
    type!: string | undefined;
    supported_resolutions!: string[] | undefined;
    pricescale!: number;
    ticker!: string | undefined;

    constructor(data?: IChartSymbolDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.exchangetraded = _data["exchangetraded"];
            this.exchangelisted = _data["exchangelisted"];
            this.timezone = _data["timezone"];
            this.minmov = _data["minmov"];
            this.minmov2 = _data["minmov2"];
            this.pointvalue = _data["pointvalue"];
            this.session = _data["session"];
            this.has_intraday = _data["has_intraday"];
            this.has_no_volume = _data["has_no_volume"];
            this.description = _data["description"];
            this.type = _data["type"];
            if (Array.isArray(_data["supported_resolutions"])) {
                this.supported_resolutions = [] as any;
                for (let item of _data["supported_resolutions"])
                    this.supported_resolutions!.push(item);
            }
            this.pricescale = _data["pricescale"];
            this.ticker = _data["ticker"];
        }
    }

    static fromJS(data: any): ChartSymbolDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChartSymbolDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["exchangetraded"] = this.exchangetraded;
        data["exchangelisted"] = this.exchangelisted;
        data["timezone"] = this.timezone;
        data["minmov"] = this.minmov;
        data["minmov2"] = this.minmov2;
        data["pointvalue"] = this.pointvalue;
        data["session"] = this.session;
        data["has_intraday"] = this.has_intraday;
        data["has_no_volume"] = this.has_no_volume;
        data["description"] = this.description;
        data["type"] = this.type;
        if (Array.isArray(this.supported_resolutions)) {
            data["supported_resolutions"] = [];
            for (let item of this.supported_resolutions)
                data["supported_resolutions"].push(item);
        }
        data["pricescale"] = this.pricescale;
        data["ticker"] = this.ticker;
        return data;
    }
}

export interface IChartSymbolDto {
    name: string | undefined;
    exchangetraded: string | undefined;
    exchangelisted: string | undefined;
    timezone: string | undefined;
    minmov: number;
    minmov2: number;
    pointvalue: number;
    session: string | undefined;
    has_intraday: boolean;
    has_no_volume: boolean;
    description: string | undefined;
    type: string | undefined;
    supported_resolutions: string[] | undefined;
    pricescale: number;
    ticker: string | undefined;
}

export class ChartSymbolsTypeDto implements IChartSymbolsTypeDto {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: IChartSymbolsTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ChartSymbolsTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChartSymbolsTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IChartSymbolsTypeDto {
    name: string | undefined;
    value: string | undefined;
}

export class ChartTemplateDto implements IChartTemplateDto {
    id!: number;
    name!: string | undefined;
    timestamp!: number;
    symbol!: string | undefined;
    resolution!: string | undefined;
    content!: string | undefined;

    constructor(data?: IChartTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.timestamp = _data["timestamp"];
            this.symbol = _data["symbol"];
            this.resolution = _data["resolution"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): ChartTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChartTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["timestamp"] = this.timestamp;
        data["symbol"] = this.symbol;
        data["resolution"] = this.resolution;
        data["content"] = this.content;
        return data;
    }
}

export interface IChartTemplateDto {
    id: number;
    name: string | undefined;
    timestamp: number;
    symbol: string | undefined;
    resolution: string | undefined;
    content: string | undefined;
}

export class CloseAllOrdersInputDto implements ICloseAllOrdersInputDto {
    closeSymbolType!: string;
    operationType!: EnCloseType;
    accountNo!: number;
    platformCode!: string;

    constructor(data?: ICloseAllOrdersInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.closeSymbolType = _data["closeSymbolType"];
            this.operationType = _data["operationType"];
            this.accountNo = _data["accountNo"];
            this.platformCode = _data["platformCode"];
        }
    }

    static fromJS(data: any): CloseAllOrdersInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CloseAllOrdersInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["closeSymbolType"] = this.closeSymbolType;
        data["operationType"] = this.operationType;
        data["accountNo"] = this.accountNo;
        data["platformCode"] = this.platformCode;
        return data;
    }
}

export interface ICloseAllOrdersInputDto {
    closeSymbolType: string;
    operationType: EnCloseType;
    accountNo: number;
    platformCode: string;
}

export class CloseAllOrdersOutputDto implements ICloseAllOrdersOutputDto {
    succesOrders!: TradeRecordDto[] | undefined;
    failedOrders!: TradeRecordDto[] | undefined;

    constructor(data?: ICloseAllOrdersOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["succesOrders"])) {
                this.succesOrders = [] as any;
                for (let item of _data["succesOrders"])
                    this.succesOrders!.push(TradeRecordDto.fromJS(item));
            }
            if (Array.isArray(_data["failedOrders"])) {
                this.failedOrders = [] as any;
                for (let item of _data["failedOrders"])
                    this.failedOrders!.push(TradeRecordDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CloseAllOrdersOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CloseAllOrdersOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.succesOrders)) {
            data["succesOrders"] = [];
            for (let item of this.succesOrders)
                data["succesOrders"].push(item.toJSON());
        }
        if (Array.isArray(this.failedOrders)) {
            data["failedOrders"] = [];
            for (let item of this.failedOrders)
                data["failedOrders"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICloseAllOrdersOutputDto {
    succesOrders: TradeRecordDto[] | undefined;
    failedOrders: TradeRecordDto[] | undefined;
}

export class CloseOrderInputDto implements ICloseOrderInputDto {
    orderId!: number;
    cmd!: number;
    volume!: number;
    symbol!: string;
    price!: number;
    sl!: number;
    tp!: number;
    accountNo!: number;
    platformCode!: string;

    constructor(data?: ICloseOrderInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.cmd = _data["cmd"];
            this.volume = _data["volume"];
            this.symbol = _data["symbol"];
            this.price = _data["price"];
            this.sl = _data["sl"];
            this.tp = _data["tp"];
            this.accountNo = _data["accountNo"];
            this.platformCode = _data["platformCode"];
        }
    }

    static fromJS(data: any): CloseOrderInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CloseOrderInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["cmd"] = this.cmd;
        data["volume"] = this.volume;
        data["symbol"] = this.symbol;
        data["price"] = this.price;
        data["sl"] = this.sl;
        data["tp"] = this.tp;
        data["accountNo"] = this.accountNo;
        data["platformCode"] = this.platformCode;
        return data;
    }
}

export interface ICloseOrderInputDto {
    orderId: number;
    cmd: number;
    volume: number;
    symbol: string;
    price: number;
    sl: number;
    tp: number;
    accountNo: number;
    platformCode: string;
}

export class CloseOrderOutputDto implements ICloseOrderOutputDto {
    tradeTransaction!: TradeTransactionDto;

    constructor(data?: ICloseOrderOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradeTransaction = _data["tradeTransaction"] ? TradeTransactionDto.fromJS(_data["tradeTransaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CloseOrderOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CloseOrderOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradeTransaction"] = this.tradeTransaction ? this.tradeTransaction.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICloseOrderOutputDto {
    tradeTransaction: TradeTransactionDto;
}

export class ConGroupDto implements IConGroupDto {
    name!: string | undefined;
    enable!: number;
    currency!: string | undefined;
    secGroups!: ConGroupSecDto[] | undefined;

    constructor(data?: IConGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.enable = _data["enable"];
            this.currency = _data["currency"];
            if (Array.isArray(_data["secGroups"])) {
                this.secGroups = [] as any;
                for (let item of _data["secGroups"])
                    this.secGroups!.push(ConGroupSecDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["enable"] = this.enable;
        data["currency"] = this.currency;
        if (Array.isArray(this.secGroups)) {
            data["secGroups"] = [];
            for (let item of this.secGroups)
                data["secGroups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IConGroupDto {
    name: string | undefined;
    enable: number;
    currency: string | undefined;
    secGroups: ConGroupSecDto[] | undefined;
}

export class ConGroupSecDto implements IConGroupSecDto {
    show!: number;
    trade!: number;
    spreadDiff!: number;
    lotMin!: number;
    lotMax!: number;
    lotStep!: number;

    constructor(data?: IConGroupSecDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.show = _data["show"];
            this.trade = _data["trade"];
            this.spreadDiff = _data["spreadDiff"];
            this.lotMin = _data["lotMin"];
            this.lotMax = _data["lotMax"];
            this.lotStep = _data["lotStep"];
        }
    }

    static fromJS(data: any): ConGroupSecDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConGroupSecDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["show"] = this.show;
        data["trade"] = this.trade;
        data["spreadDiff"] = this.spreadDiff;
        data["lotMin"] = this.lotMin;
        data["lotMax"] = this.lotMax;
        data["lotStep"] = this.lotStep;
        return data;
    }
}

export interface IConGroupSecDto {
    show: number;
    trade: number;
    spreadDiff: number;
    lotMin: number;
    lotMax: number;
    lotStep: number;
}

export class ConSymbolDto implements IConSymbolDto {
    symbol!: string | undefined;
    description!: string | undefined;
    source!: string | undefined;
    currency!: string | undefined;
    type!: number;
    typeName!: string | undefined;
    digits!: number;
    spread!: number;
    spreadBalance!: number;
    contractSize!: number;
    tickValue!: number;
    tickSize!: number;
    marginDivider!: number;
    point!: number;
    multiply!: number;
    longOnly!: number;
    marginCurrency!: string | undefined;
    isWatchList!: boolean;

    constructor(data?: IConSymbolDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.symbol = _data["symbol"];
            this.description = _data["description"];
            this.source = _data["source"];
            this.currency = _data["currency"];
            this.type = _data["type"];
            this.typeName = _data["typeName"];
            this.digits = _data["digits"];
            this.spread = _data["spread"];
            this.spreadBalance = _data["spreadBalance"];
            this.contractSize = _data["contractSize"];
            this.tickValue = _data["tickValue"];
            this.tickSize = _data["tickSize"];
            this.marginDivider = _data["marginDivider"];
            this.point = _data["point"];
            this.multiply = _data["multiply"];
            this.longOnly = _data["longOnly"];
            this.marginCurrency = _data["marginCurrency"];
            this.isWatchList = _data["isWatchList"];
        }
    }

    static fromJS(data: any): ConSymbolDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConSymbolDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["symbol"] = this.symbol;
        data["description"] = this.description;
        data["source"] = this.source;
        data["currency"] = this.currency;
        data["type"] = this.type;
        data["typeName"] = this.typeName;
        data["digits"] = this.digits;
        data["spread"] = this.spread;
        data["spreadBalance"] = this.spreadBalance;
        data["contractSize"] = this.contractSize;
        data["tickValue"] = this.tickValue;
        data["tickSize"] = this.tickSize;
        data["marginDivider"] = this.marginDivider;
        data["point"] = this.point;
        data["multiply"] = this.multiply;
        data["longOnly"] = this.longOnly;
        data["marginCurrency"] = this.marginCurrency;
        data["isWatchList"] = this.isWatchList;
        return data;
    }
}

export interface IConSymbolDto {
    symbol: string | undefined;
    description: string | undefined;
    source: string | undefined;
    currency: string | undefined;
    type: number;
    typeName: string | undefined;
    digits: number;
    spread: number;
    spreadBalance: number;
    contractSize: number;
    tickValue: number;
    tickSize: number;
    marginDivider: number;
    point: number;
    multiply: number;
    longOnly: number;
    marginCurrency: string | undefined;
    isWatchList: boolean;
}

export class CreateOrEditAlarmDto implements ICreateOrEditAlarmDto {
    id!: string | undefined;
    alarmName!: string;
    description!: string | undefined;
    price!: number;
    expiration!: DateTime | undefined;
    maxIterations!: number;
    condition!: AlarmCondition;
    symbol!: string;
    accountNo!: number;
    platformCode!: string;

    constructor(data?: ICreateOrEditAlarmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.alarmName = _data["alarmName"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.expiration = _data["expiration"] ? DateTime.fromISO(_data["expiration"].toString()) : <any>undefined;
            this.maxIterations = _data["maxIterations"];
            this.condition = _data["condition"];
            this.symbol = _data["symbol"];
            this.accountNo = _data["accountNo"];
            this.platformCode = _data["platformCode"];
        }
    }

    static fromJS(data: any): CreateOrEditAlarmDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAlarmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["alarmName"] = this.alarmName;
        data["description"] = this.description;
        data["price"] = this.price;
        data["expiration"] = this.expiration ? this.expiration.toString() : <any>undefined;
        data["maxIterations"] = this.maxIterations;
        data["condition"] = this.condition;
        data["symbol"] = this.symbol;
        data["accountNo"] = this.accountNo;
        data["platformCode"] = this.platformCode;
        return data;
    }
}

export interface ICreateOrEditAlarmDto {
    id: string | undefined;
    alarmName: string;
    description: string | undefined;
    price: number;
    expiration: DateTime | undefined;
    maxIterations: number;
    condition: AlarmCondition;
    symbol: string;
    accountNo: number;
    platformCode: string;
}

export class CreateOrEditAlarmOutput implements ICreateOrEditAlarmOutput {
    alarm!: CreateOrEditAlarmDto;

    constructor(data?: ICreateOrEditAlarmOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alarm = _data["alarm"] ? CreateOrEditAlarmDto.fromJS(_data["alarm"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrEditAlarmOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditAlarmOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alarm"] = this.alarm ? this.alarm.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrEditAlarmOutput {
    alarm: CreateOrEditAlarmDto;
}

export class CreateOrEditChartTemplateInputDto implements ICreateOrEditChartTemplateInputDto {
    id!: number | undefined;
    name!: string | undefined;
    content!: string | undefined;
    symbol!: string | undefined;
    resolution!: string | undefined;
    accountNo!: number;
    platformCode!: string;

    constructor(data?: ICreateOrEditChartTemplateInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.content = _data["content"];
            this.symbol = _data["symbol"];
            this.resolution = _data["resolution"];
            this.accountNo = _data["accountNo"];
            this.platformCode = _data["platformCode"];
        }
    }

    static fromJS(data: any): CreateOrEditChartTemplateInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditChartTemplateInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["content"] = this.content;
        data["symbol"] = this.symbol;
        data["resolution"] = this.resolution;
        data["accountNo"] = this.accountNo;
        data["platformCode"] = this.platformCode;
        return data;
    }
}

export interface ICreateOrEditChartTemplateInputDto {
    id: number | undefined;
    name: string | undefined;
    content: string | undefined;
    symbol: string | undefined;
    resolution: string | undefined;
    accountNo: number;
    platformCode: string;
}

export class CreateOrEditChartTemplateOutputDto implements ICreateOrEditChartTemplateOutputDto {
    id!: number | undefined;
    status!: string | undefined;

    constructor(data?: ICreateOrEditChartTemplateOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CreateOrEditChartTemplateOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditChartTemplateOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface ICreateOrEditChartTemplateOutputDto {
    id: number | undefined;
    status: string | undefined;
}

export class CreateOrEditStudyTemplateInputDto implements ICreateOrEditStudyTemplateInputDto {
    id!: number | undefined;
    name!: string | undefined;
    content!: string | undefined;
    meta_info!: any | undefined;
    accountNo!: number;
    platformCode!: string;

    constructor(data?: ICreateOrEditStudyTemplateInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.content = _data["content"];
            this.meta_info = _data["meta_info"];
            this.accountNo = _data["accountNo"];
            this.platformCode = _data["platformCode"];
        }
    }

    static fromJS(data: any): CreateOrEditStudyTemplateInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditStudyTemplateInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["content"] = this.content;
        data["meta_info"] = this.meta_info;
        data["accountNo"] = this.accountNo;
        data["platformCode"] = this.platformCode;
        return data;
    }
}

export interface ICreateOrEditStudyTemplateInputDto {
    id: number | undefined;
    name: string | undefined;
    content: string | undefined;
    meta_info: any | undefined;
    accountNo: number;
    platformCode: string;
}

export class CreateOrEditStudyTemplateOutputDto implements ICreateOrEditStudyTemplateOutputDto {
    id!: number | undefined;
    status!: string | undefined;

    constructor(data?: ICreateOrEditStudyTemplateOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CreateOrEditStudyTemplateOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrEditStudyTemplateOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface ICreateOrEditStudyTemplateOutputDto {
    id: number | undefined;
    status: string | undefined;
}

export class CreateOrderInputDto implements ICreateOrderInputDto {
    cmd!: number;
    volume!: number;
    symbol!: string;
    price!: number;
    expireDate!: DateTime | undefined;
    sl!: number;
    tp!: number;
    accountNo!: number;
    platformCode!: string;

    constructor(data?: ICreateOrderInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cmd = _data["cmd"];
            this.volume = _data["volume"];
            this.symbol = _data["symbol"];
            this.price = _data["price"];
            this.expireDate = _data["expireDate"] ? DateTime.fromISO(_data["expireDate"].toString()) : <any>undefined;
            this.sl = _data["sl"];
            this.tp = _data["tp"];
            this.accountNo = _data["accountNo"];
            this.platformCode = _data["platformCode"];
        }
    }

    static fromJS(data: any): CreateOrderInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cmd"] = this.cmd;
        data["volume"] = this.volume;
        data["symbol"] = this.symbol;
        data["price"] = this.price;
        data["expireDate"] = this.expireDate ? this.expireDate.toString() : <any>undefined;
        data["sl"] = this.sl;
        data["tp"] = this.tp;
        data["accountNo"] = this.accountNo;
        data["platformCode"] = this.platformCode;
        return data;
    }
}

export interface ICreateOrderInputDto {
    cmd: number;
    volume: number;
    symbol: string;
    price: number;
    expireDate: DateTime | undefined;
    sl: number;
    tp: number;
    accountNo: number;
    platformCode: string;
}

export class CreateOrderOutputDto implements ICreateOrderOutputDto {
    tradeTransaction!: TradeTransactionDto;

    constructor(data?: ICreateOrderOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradeTransaction = _data["tradeTransaction"] ? TradeTransactionDto.fromJS(_data["tradeTransaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateOrderOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradeTransaction"] = this.tradeTransaction ? this.tradeTransaction.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrderOutputDto {
    tradeTransaction: TradeTransactionDto;
}

export class CreateTradingAccountInputDto implements ICreateTradingAccountInputDto {
    platformCode!: string;

    constructor(data?: ICreateTradingAccountInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.platformCode = _data["platformCode"];
        }
    }

    static fromJS(data: any): CreateTradingAccountInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTradingAccountInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["platformCode"] = this.platformCode;
        return data;
    }
}

export interface ICreateTradingAccountInputDto {
    platformCode: string;
}

export class CreateTradingAccountOutputDto implements ICreateTradingAccountOutputDto {
    accountNo!: number;
    platformCode!: string | undefined;

    constructor(data?: ICreateTradingAccountOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNo = _data["accountNo"];
            this.platformCode = _data["platformCode"];
        }
    }

    static fromJS(data: any): CreateTradingAccountOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTradingAccountOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNo"] = this.accountNo;
        data["platformCode"] = this.platformCode;
        return data;
    }
}

export interface ICreateTradingAccountOutputDto {
    accountNo: number;
    platformCode: string | undefined;
}

export class DeleteChartTemplateInputDto implements IDeleteChartTemplateInputDto {
    id!: number;
    accountNo!: number;
    platformCode!: string;

    constructor(data?: IDeleteChartTemplateInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountNo = _data["accountNo"];
            this.platformCode = _data["platformCode"];
        }
    }

    static fromJS(data: any): DeleteChartTemplateInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteChartTemplateInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountNo"] = this.accountNo;
        data["platformCode"] = this.platformCode;
        return data;
    }
}

export interface IDeleteChartTemplateInputDto {
    id: number;
    accountNo: number;
    platformCode: string;
}

export class DeleteChartTemplateOutputDto implements IDeleteChartTemplateOutputDto {
    status!: string | undefined;

    constructor(data?: IDeleteChartTemplateOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): DeleteChartTemplateOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteChartTemplateOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    }
}

export interface IDeleteChartTemplateOutputDto {
    status: string | undefined;
}

export class DeleteOrderInputDto implements IDeleteOrderInputDto {
    orderId!: number;
    accountNo!: number;
    platformCode!: string;

    constructor(data?: IDeleteOrderInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.accountNo = _data["accountNo"];
            this.platformCode = _data["platformCode"];
        }
    }

    static fromJS(data: any): DeleteOrderInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteOrderInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["accountNo"] = this.accountNo;
        data["platformCode"] = this.platformCode;
        return data;
    }
}

export interface IDeleteOrderInputDto {
    orderId: number;
    accountNo: number;
    platformCode: string;
}

export class DeleteOrderOutputDto implements IDeleteOrderOutputDto {
    tradeTransaction!: TradeTransactionDto;

    constructor(data?: IDeleteOrderOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradeTransaction = _data["tradeTransaction"] ? TradeTransactionDto.fromJS(_data["tradeTransaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DeleteOrderOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteOrderOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradeTransaction"] = this.tradeTransaction ? this.tradeTransaction.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeleteOrderOutputDto {
    tradeTransaction: TradeTransactionDto;
}

export class DeleteStudyTemplateInputDto implements IDeleteStudyTemplateInputDto {
    name!: string;
    accountNo!: number;
    platformCode!: string;

    constructor(data?: IDeleteStudyTemplateInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.accountNo = _data["accountNo"];
            this.platformCode = _data["platformCode"];
        }
    }

    static fromJS(data: any): DeleteStudyTemplateInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteStudyTemplateInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["accountNo"] = this.accountNo;
        data["platformCode"] = this.platformCode;
        return data;
    }
}

export interface IDeleteStudyTemplateInputDto {
    name: string;
    accountNo: number;
    platformCode: string;
}

export class DeleteStudyTemplateOutputDto implements IDeleteStudyTemplateOutputDto {
    status!: string | undefined;

    constructor(data?: IDeleteStudyTemplateOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): DeleteStudyTemplateOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteStudyTemplateOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        return data;
    }
}

export interface IDeleteStudyTemplateOutputDto {
    status: string | undefined;
}

export class EditionInfoDto implements IEditionInfoDto {
    displayName!: string | undefined;
    trialDayCount!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    isHighestEdition!: boolean;
    isFree!: boolean;
    id!: number;

    constructor(data?: IEditionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.trialDayCount = _data["trialDayCount"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.isHighestEdition = _data["isHighestEdition"];
            this.isFree = _data["isFree"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EditionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["trialDayCount"] = this.trialDayCount;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["isHighestEdition"] = this.isHighestEdition;
        data["isFree"] = this.isFree;
        data["id"] = this.id;
        return data;
    }
}

export interface IEditionInfoDto {
    displayName: string | undefined;
    trialDayCount: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    isHighestEdition: boolean;
    isFree: boolean;
    id: number;
}

export enum EnCloseType {
    CloseAllOrder = 0,
    CloseAllBuyOrder = 1,
    CloseAllSellOrder = 2,
    CloseAllPositiveOrder = 3,
    CloseAllNegativeOrder = 4,
}

export enum EnServerType {
    Demo = 0,
    Real = 1,
    Test = 2,
}

export class GetAlarmForEditInput implements IGetAlarmForEditInput {
    id!: string;
    accountNo!: number;
    platformCode!: string;

    constructor(data?: IGetAlarmForEditInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountNo = _data["accountNo"];
            this.platformCode = _data["platformCode"];
        }
    }

    static fromJS(data: any): GetAlarmForEditInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAlarmForEditInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountNo"] = this.accountNo;
        data["platformCode"] = this.platformCode;
        return data;
    }
}

export interface IGetAlarmForEditInput {
    id: string;
    accountNo: number;
    platformCode: string;
}

export class GetAlarmForEditOutput implements IGetAlarmForEditOutput {
    alarm!: CreateOrEditAlarmDto;

    constructor(data?: IGetAlarmForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alarm = _data["alarm"] ? CreateOrEditAlarmDto.fromJS(_data["alarm"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAlarmForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAlarmForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alarm"] = this.alarm ? this.alarm.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAlarmForEditOutput {
    alarm: CreateOrEditAlarmDto;
}

export class GetAllAlarmsInput implements IGetAllAlarmsInput {
    accountNo!: number;
    platformCode!: string;

    constructor(data?: IGetAllAlarmsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNo = _data["accountNo"];
            this.platformCode = _data["platformCode"];
        }
    }

    static fromJS(data: any): GetAllAlarmsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllAlarmsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNo"] = this.accountNo;
        data["platformCode"] = this.platformCode;
        return data;
    }
}

export interface IGetAllAlarmsInput {
    accountNo: number;
    platformCode: string;
}

export class GetAllAlarmsOutput implements IGetAllAlarmsOutput {
    alarms!: AlarmDto[] | undefined;

    constructor(data?: IGetAllAlarmsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["alarms"])) {
                this.alarms = [] as any;
                for (let item of _data["alarms"])
                    this.alarms!.push(AlarmDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllAlarmsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllAlarmsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.alarms)) {
            data["alarms"] = [];
            for (let item of this.alarms)
                data["alarms"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllAlarmsOutput {
    alarms: AlarmDto[] | undefined;
}

export class GetAllChartTemplatesOutput implements IGetAllChartTemplatesOutput {
    chartTemplates!: ChartTemplateDto[] | undefined;

    constructor(data?: IGetAllChartTemplatesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["chartTemplates"])) {
                this.chartTemplates = [] as any;
                for (let item of _data["chartTemplates"])
                    this.chartTemplates!.push(ChartTemplateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllChartTemplatesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllChartTemplatesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.chartTemplates)) {
            data["chartTemplates"] = [];
            for (let item of this.chartTemplates)
                data["chartTemplates"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllChartTemplatesOutput {
    chartTemplates: ChartTemplateDto[] | undefined;
}

export class GetAllStudyTemplatesOutput implements IGetAllStudyTemplatesOutput {
    studyTemplates!: StudyTemplateDto[] | undefined;

    constructor(data?: IGetAllStudyTemplatesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["studyTemplates"])) {
                this.studyTemplates = [] as any;
                for (let item of _data["studyTemplates"])
                    this.studyTemplates!.push(StudyTemplateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllStudyTemplatesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllStudyTemplatesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.studyTemplates)) {
            data["studyTemplates"] = [];
            for (let item of this.studyTemplates)
                data["studyTemplates"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetAllStudyTemplatesOutput {
    studyTemplates: StudyTemplateDto[] | undefined;
}

export class GetChartHistoryOutputDto implements IGetChartHistoryOutputDto {
    histories!: ChartHistoryDto[] | undefined;
    success!: string | undefined;
    nextTime!: number | undefined;

    constructor(data?: IGetChartHistoryOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["histories"])) {
                this.histories = [] as any;
                for (let item of _data["histories"])
                    this.histories!.push(ChartHistoryDto.fromJS(item));
            }
            this.success = _data["success"];
            this.nextTime = _data["nextTime"];
        }
    }

    static fromJS(data: any): GetChartHistoryOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetChartHistoryOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.histories)) {
            data["histories"] = [];
            for (let item of this.histories)
                data["histories"].push(item.toJSON());
        }
        data["success"] = this.success;
        data["nextTime"] = this.nextTime;
        return data;
    }
}

export interface IGetChartHistoryOutputDto {
    histories: ChartHistoryDto[] | undefined;
    success: string | undefined;
    nextTime: number | undefined;
}

export class GetChartTemplateInputDto implements IGetChartTemplateInputDto {
    id!: number;
    accountNo!: number;
    platformCode!: string;

    constructor(data?: IGetChartTemplateInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountNo = _data["accountNo"];
            this.platformCode = _data["platformCode"];
        }
    }

    static fromJS(data: any): GetChartTemplateInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetChartTemplateInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountNo"] = this.accountNo;
        data["platformCode"] = this.platformCode;
        return data;
    }
}

export interface IGetChartTemplateInputDto {
    id: number;
    accountNo: number;
    platformCode: string;
}

export class GetChartTemplateOutputDto implements IGetChartTemplateOutputDto {
    status!: string | undefined;
    chartTemplate!: ChartTemplateDto;

    constructor(data?: IGetChartTemplateOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.chartTemplate = _data["chartTemplate"] ? ChartTemplateDto.fromJS(_data["chartTemplate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetChartTemplateOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetChartTemplateOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["chartTemplate"] = this.chartTemplate ? this.chartTemplate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetChartTemplateOutputDto {
    status: string | undefined;
    chartTemplate: ChartTemplateDto;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    user!: UserLoginInfoDto;
    impersonatorUser!: UserLoginInfoDto;
    tenant!: TenantLoginInfoDto;
    impersonatorTenant!: TenantLoginInfoDto;
    application!: ApplicationInfoDto;
    theme!: UiCustomizationSettingsDto;
    brokers!: BrokerSummaryDto[] | undefined;
    symbols!: ConSymbolDto[] | undefined;
    defaultWatchListSymbols!: string[] | undefined;
    tradingAccountInfo!: TradingAccountInfoDto;
    group!: ConGroupDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.impersonatorUser = _data["impersonatorUser"] ? UserLoginInfoDto.fromJS(_data["impersonatorUser"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
            this.impersonatorTenant = _data["impersonatorTenant"] ? TenantLoginInfoDto.fromJS(_data["impersonatorTenant"]) : <any>undefined;
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.theme = _data["theme"] ? UiCustomizationSettingsDto.fromJS(_data["theme"]) : <any>undefined;
            if (Array.isArray(_data["brokers"])) {
                this.brokers = [] as any;
                for (let item of _data["brokers"])
                    this.brokers!.push(BrokerSummaryDto.fromJS(item));
            }
            if (Array.isArray(_data["symbols"])) {
                this.symbols = [] as any;
                for (let item of _data["symbols"])
                    this.symbols!.push(ConSymbolDto.fromJS(item));
            }
            if (Array.isArray(_data["defaultWatchListSymbols"])) {
                this.defaultWatchListSymbols = [] as any;
                for (let item of _data["defaultWatchListSymbols"])
                    this.defaultWatchListSymbols!.push(item);
            }
            this.tradingAccountInfo = _data["tradingAccountInfo"] ? TradingAccountInfoDto.fromJS(_data["tradingAccountInfo"]) : <any>undefined;
            this.group = _data["group"] ? ConGroupDto.fromJS(_data["group"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["impersonatorUser"] = this.impersonatorUser ? this.impersonatorUser.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["impersonatorTenant"] = this.impersonatorTenant ? this.impersonatorTenant.toJSON() : <any>undefined;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["theme"] = this.theme ? this.theme.toJSON() : <any>undefined;
        if (Array.isArray(this.brokers)) {
            data["brokers"] = [];
            for (let item of this.brokers)
                data["brokers"].push(item.toJSON());
        }
        if (Array.isArray(this.symbols)) {
            data["symbols"] = [];
            for (let item of this.symbols)
                data["symbols"].push(item.toJSON());
        }
        if (Array.isArray(this.defaultWatchListSymbols)) {
            data["defaultWatchListSymbols"] = [];
            for (let item of this.defaultWatchListSymbols)
                data["defaultWatchListSymbols"].push(item);
        }
        data["tradingAccountInfo"] = this.tradingAccountInfo ? this.tradingAccountInfo.toJSON() : <any>undefined;
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    user: UserLoginInfoDto;
    impersonatorUser: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    impersonatorTenant: TenantLoginInfoDto;
    application: ApplicationInfoDto;
    theme: UiCustomizationSettingsDto;
    brokers: BrokerSummaryDto[] | undefined;
    symbols: ConSymbolDto[] | undefined;
    defaultWatchListSymbols: string[] | undefined;
    tradingAccountInfo: TradingAccountInfoDto;
    group: ConGroupDto;
}

export class GetOrderHistoryInputDto implements IGetOrderHistoryInputDto {
    startDate!: DateTime;
    endDate!: DateTime;
    accountNo!: number;
    platformCode!: string;

    constructor(data?: IGetOrderHistoryInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
            this.accountNo = _data["accountNo"];
            this.platformCode = _data["platformCode"];
        }
    }

    static fromJS(data: any): GetOrderHistoryInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderHistoryInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        data["accountNo"] = this.accountNo;
        data["platformCode"] = this.platformCode;
        return data;
    }
}

export interface IGetOrderHistoryInputDto {
    startDate: DateTime;
    endDate: DateTime;
    accountNo: number;
    platformCode: string;
}

export class GetOrderHistoryOutputDto implements IGetOrderHistoryOutputDto {
    histories!: HistoryDto[] | undefined;

    constructor(data?: IGetOrderHistoryOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["histories"])) {
                this.histories = [] as any;
                for (let item of _data["histories"])
                    this.histories!.push(HistoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetOrderHistoryOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderHistoryOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.histories)) {
            data["histories"] = [];
            for (let item of this.histories)
                data["histories"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetOrderHistoryOutputDto {
    histories: HistoryDto[] | undefined;
}

export class GetStudyTemplateInputDto implements IGetStudyTemplateInputDto {
    name!: string;
    accountNo!: number;
    platformCode!: string;

    constructor(data?: IGetStudyTemplateInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.accountNo = _data["accountNo"];
            this.platformCode = _data["platformCode"];
        }
    }

    static fromJS(data: any): GetStudyTemplateInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetStudyTemplateInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["accountNo"] = this.accountNo;
        data["platformCode"] = this.platformCode;
        return data;
    }
}

export interface IGetStudyTemplateInputDto {
    name: string;
    accountNo: number;
    platformCode: string;
}

export class GetStudyTemplateOutputDto implements IGetStudyTemplateOutputDto {
    status!: string | undefined;
    studyTemplate!: StudyTemplateDto;

    constructor(data?: IGetStudyTemplateOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.studyTemplate = _data["studyTemplate"] ? StudyTemplateDto.fromJS(_data["studyTemplate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetStudyTemplateOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetStudyTemplateOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["studyTemplate"] = this.studyTemplate ? this.studyTemplate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetStudyTemplateOutputDto {
    status: string | undefined;
    studyTemplate: StudyTemplateDto;
}

export class GetTradingAccountInfoOutputDto implements IGetTradingAccountInfoOutputDto {
    symbols!: ConSymbolDto[] | undefined;
    defaultWatchListSymbols!: string[] | undefined;
    group!: ConGroupDto;
    tradingAccountInfo!: TradingAccountInfoDto;

    constructor(data?: IGetTradingAccountInfoOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["symbols"])) {
                this.symbols = [] as any;
                for (let item of _data["symbols"])
                    this.symbols!.push(ConSymbolDto.fromJS(item));
            }
            if (Array.isArray(_data["defaultWatchListSymbols"])) {
                this.defaultWatchListSymbols = [] as any;
                for (let item of _data["defaultWatchListSymbols"])
                    this.defaultWatchListSymbols!.push(item);
            }
            this.group = _data["group"] ? ConGroupDto.fromJS(_data["group"]) : <any>undefined;
            this.tradingAccountInfo = _data["tradingAccountInfo"] ? TradingAccountInfoDto.fromJS(_data["tradingAccountInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTradingAccountInfoOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTradingAccountInfoOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.symbols)) {
            data["symbols"] = [];
            for (let item of this.symbols)
                data["symbols"].push(item.toJSON());
        }
        if (Array.isArray(this.defaultWatchListSymbols)) {
            data["defaultWatchListSymbols"] = [];
            for (let item of this.defaultWatchListSymbols)
                data["defaultWatchListSymbols"].push(item);
        }
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        data["tradingAccountInfo"] = this.tradingAccountInfo ? this.tradingAccountInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTradingAccountInfoOutputDto {
    symbols: ConSymbolDto[] | undefined;
    defaultWatchListSymbols: string[] | undefined;
    group: ConGroupDto;
    tradingAccountInfo: TradingAccountInfoDto;
}

export class HistoryDto implements IHistoryDto {
    order!: number;
    symbol!: string | undefined;
    digits!: number;
    cmd!: number;
    volume!: number;
    openTime!: DateTime;
    openPrice!: number;
    sl!: number;
    tp!: number;
    closeTime!: DateTime;
    closePrice!: number;
    expiration!: DateTime;
    commission!: number;
    commissionAgent!: number;
    swap!: number;
    profit!: number;
    taxes!: number;
    magic!: number;
    comment!: string | undefined;

    constructor(data?: IHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.symbol = _data["symbol"];
            this.digits = _data["digits"];
            this.cmd = _data["cmd"];
            this.volume = _data["volume"];
            this.openTime = _data["openTime"] ? DateTime.fromISO(_data["openTime"].toString()) : <any>undefined;
            this.openPrice = _data["openPrice"];
            this.sl = _data["sl"];
            this.tp = _data["tp"];
            this.closeTime = _data["closeTime"] ? DateTime.fromISO(_data["closeTime"].toString()) : <any>undefined;
            this.closePrice = _data["closePrice"];
            this.expiration = _data["expiration"] ? DateTime.fromISO(_data["expiration"].toString()) : <any>undefined;
            this.commission = _data["commission"];
            this.commissionAgent = _data["commissionAgent"];
            this.swap = _data["swap"];
            this.profit = _data["profit"];
            this.taxes = _data["taxes"];
            this.magic = _data["magic"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): HistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new HistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["symbol"] = this.symbol;
        data["digits"] = this.digits;
        data["cmd"] = this.cmd;
        data["volume"] = this.volume;
        data["openTime"] = this.openTime ? this.openTime.toString() : <any>undefined;
        data["openPrice"] = this.openPrice;
        data["sl"] = this.sl;
        data["tp"] = this.tp;
        data["closeTime"] = this.closeTime ? this.closeTime.toString() : <any>undefined;
        data["closePrice"] = this.closePrice;
        data["expiration"] = this.expiration ? this.expiration.toString() : <any>undefined;
        data["commission"] = this.commission;
        data["commissionAgent"] = this.commissionAgent;
        data["swap"] = this.swap;
        data["profit"] = this.profit;
        data["taxes"] = this.taxes;
        data["magic"] = this.magic;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IHistoryDto {
    order: number;
    symbol: string | undefined;
    digits: number;
    cmd: number;
    volume: number;
    openTime: DateTime;
    openPrice: number;
    sl: number;
    tp: number;
    closeTime: DateTime;
    closePrice: number;
    expiration: DateTime;
    commission: number;
    commissionAgent: number;
    swap: number;
    profit: number;
    taxes: number;
    magic: number;
    comment: string | undefined;
}

export class InputBaseDto implements IInputBaseDto {
    accountNo!: number;
    platformCode!: string;

    constructor(data?: IInputBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountNo = _data["accountNo"];
            this.platformCode = _data["platformCode"];
        }
    }

    static fromJS(data: any): InputBaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new InputBaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNo"] = this.accountNo;
        data["platformCode"] = this.platformCode;
        return data;
    }
}

export interface IInputBaseDto {
    accountNo: number;
    platformCode: string;
}

export class ModifyOrderInputDto implements IModifyOrderInputDto {
    orderId!: number;
    cmd!: number;
    sl!: number;
    tp!: number;
    price!: number;
    accountNo!: number;
    platformCode!: string;

    constructor(data?: IModifyOrderInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.cmd = _data["cmd"];
            this.sl = _data["sl"];
            this.tp = _data["tp"];
            this.price = _data["price"];
            this.accountNo = _data["accountNo"];
            this.platformCode = _data["platformCode"];
        }
    }

    static fromJS(data: any): ModifyOrderInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyOrderInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["cmd"] = this.cmd;
        data["sl"] = this.sl;
        data["tp"] = this.tp;
        data["price"] = this.price;
        data["accountNo"] = this.accountNo;
        data["platformCode"] = this.platformCode;
        return data;
    }
}

export interface IModifyOrderInputDto {
    orderId: number;
    cmd: number;
    sl: number;
    tp: number;
    price: number;
    accountNo: number;
    platformCode: string;
}

export class ModifyOrderOutputDto implements IModifyOrderOutputDto {
    tradeTransaction!: TradeTransactionDto;

    constructor(data?: IModifyOrderOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradeTransaction = _data["tradeTransaction"] ? TradeTransactionDto.fromJS(_data["tradeTransaction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ModifyOrderOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyOrderOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradeTransaction"] = this.tradeTransaction ? this.tradeTransaction.toJSON() : <any>undefined;
        return data;
    }
}

export interface IModifyOrderOutputDto {
    tradeTransaction: TradeTransactionDto;
}

export class NameValueDto implements INameValueDto {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValueDto {
    name: string | undefined;
    value: string | undefined;
}

export enum PaymentPeriodType {
    Daily = 1,
    Weekly = 7,
    Monthly = 30,
    Annual = 365,
}

export class PendingOrderDto implements IPendingOrderDto {
    order!: number;
    cp!: number;
    swap!: number;
    profit!: number;
    sl!: number;
    tp!: number;
    openTime!: string | undefined;
    openPrice!: number;
    volume!: number;
    type!: string | undefined;
    symbol!: string | undefined;
    digits!: number;

    constructor(data?: IPendingOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.cp = _data["cp"];
            this.swap = _data["swap"];
            this.profit = _data["profit"];
            this.sl = _data["sl"];
            this.tp = _data["tp"];
            this.openTime = _data["openTime"];
            this.openPrice = _data["openPrice"];
            this.volume = _data["volume"];
            this.type = _data["type"];
            this.symbol = _data["symbol"];
            this.digits = _data["digits"];
        }
    }

    static fromJS(data: any): PendingOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new PendingOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["cp"] = this.cp;
        data["swap"] = this.swap;
        data["profit"] = this.profit;
        data["sl"] = this.sl;
        data["tp"] = this.tp;
        data["openTime"] = this.openTime;
        data["openPrice"] = this.openPrice;
        data["volume"] = this.volume;
        data["type"] = this.type;
        data["symbol"] = this.symbol;
        data["digits"] = this.digits;
        return data;
    }
}

export interface IPendingOrderDto {
    order: number;
    cp: number;
    swap: number;
    profit: number;
    sl: number;
    tp: number;
    openTime: string | undefined;
    openPrice: number;
    volume: number;
    type: string | undefined;
    symbol: string | undefined;
    digits: number;
}

export class PositionDto implements IPositionDto {
    order!: number;
    pp!: number;
    cp!: number;
    profit!: number;
    openTime!: string | undefined;
    type!: string | undefined;
    symbol!: string | undefined;
    volume!: number;
    openPrice!: number;
    sl!: number;
    tp!: number;
    swap!: number;
    commission!: number;
    digits!: number;

    constructor(data?: IPositionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.pp = _data["pp"];
            this.cp = _data["cp"];
            this.profit = _data["profit"];
            this.openTime = _data["openTime"];
            this.type = _data["type"];
            this.symbol = _data["symbol"];
            this.volume = _data["volume"];
            this.openPrice = _data["openPrice"];
            this.sl = _data["sl"];
            this.tp = _data["tp"];
            this.swap = _data["swap"];
            this.commission = _data["commission"];
            this.digits = _data["digits"];
        }
    }

    static fromJS(data: any): PositionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PositionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["pp"] = this.pp;
        data["cp"] = this.cp;
        data["profit"] = this.profit;
        data["openTime"] = this.openTime;
        data["type"] = this.type;
        data["symbol"] = this.symbol;
        data["volume"] = this.volume;
        data["openPrice"] = this.openPrice;
        data["sl"] = this.sl;
        data["tp"] = this.tp;
        data["swap"] = this.swap;
        data["commission"] = this.commission;
        data["digits"] = this.digits;
        return data;
    }
}

export interface IPositionDto {
    order: number;
    pp: number;
    cp: number;
    profit: number;
    openTime: string | undefined;
    type: string | undefined;
    symbol: string | undefined;
    volume: number;
    openPrice: number;
    sl: number;
    tp: number;
    swap: number;
    commission: number;
    digits: number;
}

export class RefreshTokenResult implements IRefreshTokenResult {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: IRefreshTokenResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any): RefreshTokenResult {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }
}

export interface IRefreshTokenResult {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class RegisterInput implements IRegisterInput {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    password!: string;
    captchaResponse!: string | undefined;
    isLegalAccepted!: boolean;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
            this.isLegalAccepted = _data["isLegalAccepted"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        data["isLegalAccepted"] = this.isLegalAccepted;
        return data;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
    isLegalAccepted: boolean;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin!: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class ResetPasswordInput implements IResetPasswordInput {
    userId!: number;
    resetCode!: string | undefined;
    password!: string | undefined;
    returnUrl!: string | undefined;
    singleSignIn!: string | undefined;
    c!: string | undefined;

    constructor(data?: IResetPasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.resetCode = _data["resetCode"];
            this.password = _data["password"];
            this.returnUrl = _data["returnUrl"];
            this.singleSignIn = _data["singleSignIn"];
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ResetPasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["resetCode"] = this.resetCode;
        data["password"] = this.password;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        data["c"] = this.c;
        return data;
    }
}

export interface IResetPasswordInput {
    userId: number;
    resetCode: string | undefined;
    password: string | undefined;
    returnUrl: string | undefined;
    singleSignIn: string | undefined;
    c: string | undefined;
}

export class ResetPasswordOutput implements IResetPasswordOutput {
    canLogin!: boolean;
    userName!: string | undefined;

    constructor(data?: IResetPasswordOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): ResetPasswordOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IResetPasswordOutput {
    canLogin: boolean;
    userName: string | undefined;
}

export class SendEmailActivationLinkInput implements ISendEmailActivationLinkInput {
    emailAddress!: string;

    constructor(data?: ISendEmailActivationLinkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendEmailActivationLinkInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailActivationLinkInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendEmailActivationLinkInput {
    emailAddress: string;
}

export class SendPasswordResetCodeInput implements ISendPasswordResetCodeInput {
    emailAddress!: string;

    constructor(data?: ISendPasswordResetCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendPasswordResetCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendPasswordResetCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendPasswordResetCodeInput {
    emailAddress: string;
}

export class StudyTemplateDto implements IStudyTemplateDto {
    id!: number;
    name!: string | undefined;
    timestamp!: number;
    content!: string | undefined;
    meta_info!: any | undefined;

    constructor(data?: IStudyTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.timestamp = _data["timestamp"];
            this.content = _data["content"];
            this.meta_info = _data["meta_info"];
        }
    }

    static fromJS(data: any): StudyTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["timestamp"] = this.timestamp;
        data["content"] = this.content;
        data["meta_info"] = this.meta_info;
        return data;
    }
}

export interface IStudyTemplateDto {
    id: number;
    name: string | undefined;
    timestamp: number;
    content: string | undefined;
    meta_info: any | undefined;
}

export enum SubscriptionPaymentType {
    Manual = 0,
    RecurringAutomatic = 1,
    RecurringManual = 2,
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    tenancyName!: string | undefined;
    name!: string | undefined;
    logoId!: string | undefined;
    logoFileType!: string | undefined;
    customCssId!: string | undefined;
    subscriptionEndDateUtc!: DateTime | undefined;
    isInTrialPeriod!: boolean;
    subscriptionPaymentType!: SubscriptionPaymentType;
    edition!: EditionInfoDto;
    featureValues!: NameValueDto[] | undefined;
    creationTime!: DateTime;
    paymentPeriodType!: PaymentPeriodType;
    subscriptionDateString!: string | undefined;
    creationTimeString!: string | undefined;
    id!: number;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.logoId = _data["logoId"];
            this.logoFileType = _data["logoFileType"];
            this.customCssId = _data["customCssId"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.subscriptionPaymentType = _data["subscriptionPaymentType"];
            this.edition = _data["edition"] ? EditionInfoDto.fromJS(_data["edition"]) : <any>undefined;
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.paymentPeriodType = _data["paymentPeriodType"];
            this.subscriptionDateString = _data["subscriptionDateString"];
            this.creationTimeString = _data["creationTimeString"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["logoId"] = this.logoId;
        data["logoFileType"] = this.logoFileType;
        data["customCssId"] = this.customCssId;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["subscriptionPaymentType"] = this.subscriptionPaymentType;
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionDateString"] = this.subscriptionDateString;
        data["creationTimeString"] = this.creationTimeString;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    logoId: string | undefined;
    logoFileType: string | undefined;
    customCssId: string | undefined;
    subscriptionEndDateUtc: DateTime | undefined;
    isInTrialPeriod: boolean;
    subscriptionPaymentType: SubscriptionPaymentType;
    edition: EditionInfoDto;
    featureValues: NameValueDto[] | undefined;
    creationTime: DateTime;
    paymentPeriodType: PaymentPeriodType;
    subscriptionDateString: string | undefined;
    creationTimeString: string | undefined;
    id: number;
}

export class ThemeFooterSettingsDto implements IThemeFooterSettingsDto {
    fixedFooter!: boolean;

    constructor(data?: IThemeFooterSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fixedFooter = _data["fixedFooter"];
        }
    }

    static fromJS(data: any): ThemeFooterSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeFooterSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedFooter"] = this.fixedFooter;
        return data;
    }
}

export interface IThemeFooterSettingsDto {
    fixedFooter: boolean;
}

export class ThemeHeaderSettingsDto implements IThemeHeaderSettingsDto {
    readonly desktopFixedHeader!: boolean;
    readonly mobileFixedHeader!: boolean;
    minimizeDesktopHeaderType!: string | undefined;

    constructor(data?: IThemeHeaderSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).desktopFixedHeader = _data["desktopFixedHeader"];
            (<any>this).mobileFixedHeader = _data["mobileFixedHeader"];
            this.minimizeDesktopHeaderType = _data["minimizeDesktopHeaderType"];
        }
    }

    static fromJS(data: any): ThemeHeaderSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeHeaderSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["desktopFixedHeader"] = this.desktopFixedHeader;
        data["mobileFixedHeader"] = this.mobileFixedHeader;
        data["minimizeDesktopHeaderType"] = this.minimizeDesktopHeaderType;
        return data;
    }
}

export interface IThemeHeaderSettingsDto {
    desktopFixedHeader: boolean;
    mobileFixedHeader: boolean;
    minimizeDesktopHeaderType: string | undefined;
}

export class ThemeLayoutSettingsDto implements IThemeLayoutSettingsDto {
    layoutType!: string | undefined;
    darkMode!: boolean;

    constructor(data?: IThemeLayoutSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.layoutType = _data["layoutType"];
            this.darkMode = _data["darkMode"];
        }
    }

    static fromJS(data: any): ThemeLayoutSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeLayoutSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layoutType"] = this.layoutType;
        data["darkMode"] = this.darkMode;
        return data;
    }
}

export interface IThemeLayoutSettingsDto {
    layoutType: string | undefined;
    darkMode: boolean;
}

export class ThemeMenuSettingsDto implements IThemeMenuSettingsDto {
    position!: string | undefined;
    asideSkin!: string | undefined;
    fixedAside!: boolean;
    allowAsideMinimizing!: boolean;
    defaultMinimizedAside!: boolean;
    submenuToggle!: string | undefined;
    searchActive!: boolean;
    enableSecondary!: boolean;
    hoverableAside!: boolean;

    constructor(data?: IThemeMenuSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.position = _data["position"];
            this.asideSkin = _data["asideSkin"];
            this.fixedAside = _data["fixedAside"];
            this.allowAsideMinimizing = _data["allowAsideMinimizing"];
            this.defaultMinimizedAside = _data["defaultMinimizedAside"];
            this.submenuToggle = _data["submenuToggle"];
            this.searchActive = _data["searchActive"];
            this.enableSecondary = _data["enableSecondary"];
            this.hoverableAside = _data["hoverableAside"];
        }
    }

    static fromJS(data: any): ThemeMenuSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeMenuSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["asideSkin"] = this.asideSkin;
        data["fixedAside"] = this.fixedAside;
        data["allowAsideMinimizing"] = this.allowAsideMinimizing;
        data["defaultMinimizedAside"] = this.defaultMinimizedAside;
        data["submenuToggle"] = this.submenuToggle;
        data["searchActive"] = this.searchActive;
        data["enableSecondary"] = this.enableSecondary;
        data["hoverableAside"] = this.hoverableAside;
        return data;
    }
}

export interface IThemeMenuSettingsDto {
    position: string | undefined;
    asideSkin: string | undefined;
    fixedAside: boolean;
    allowAsideMinimizing: boolean;
    defaultMinimizedAside: boolean;
    submenuToggle: string | undefined;
    searchActive: boolean;
    enableSecondary: boolean;
    hoverableAside: boolean;
}

export class ThemeSettingsDto implements IThemeSettingsDto {
    theme!: string | undefined;
    layout!: ThemeLayoutSettingsDto;
    header!: ThemeHeaderSettingsDto;
    subHeader!: ThemeSubHeaderSettingsDto;
    menu!: ThemeMenuSettingsDto;
    footer!: ThemeFooterSettingsDto;

    constructor(data?: IThemeSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
            this.layout = _data["layout"] ? ThemeLayoutSettingsDto.fromJS(_data["layout"]) : <any>undefined;
            this.header = _data["header"] ? ThemeHeaderSettingsDto.fromJS(_data["header"]) : <any>undefined;
            this.subHeader = _data["subHeader"] ? ThemeSubHeaderSettingsDto.fromJS(_data["subHeader"]) : <any>undefined;
            this.menu = _data["menu"] ? ThemeMenuSettingsDto.fromJS(_data["menu"]) : <any>undefined;
            this.footer = _data["footer"] ? ThemeFooterSettingsDto.fromJS(_data["footer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ThemeSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        data["layout"] = this.layout ? this.layout.toJSON() : <any>undefined;
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        data["subHeader"] = this.subHeader ? this.subHeader.toJSON() : <any>undefined;
        data["menu"] = this.menu ? this.menu.toJSON() : <any>undefined;
        data["footer"] = this.footer ? this.footer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IThemeSettingsDto {
    theme: string | undefined;
    layout: ThemeLayoutSettingsDto;
    header: ThemeHeaderSettingsDto;
    subHeader: ThemeSubHeaderSettingsDto;
    menu: ThemeMenuSettingsDto;
    footer: ThemeFooterSettingsDto;
}

export class ThemeSubHeaderSettingsDto implements IThemeSubHeaderSettingsDto {
    fixedSubHeader!: boolean;
    subheaderStyle!: string | undefined;
    subheaderSize!: number;
    titleStyle!: string | undefined;
    containerStyle!: string | undefined;
    subContainerStyle!: string | undefined;

    constructor(data?: IThemeSubHeaderSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fixedSubHeader = _data["fixedSubHeader"];
            this.subheaderStyle = _data["subheaderStyle"];
            this.subheaderSize = _data["subheaderSize"];
            this.titleStyle = _data["titleStyle"];
            this.containerStyle = _data["containerStyle"];
            this.subContainerStyle = _data["subContainerStyle"];
        }
    }

    static fromJS(data: any): ThemeSubHeaderSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeSubHeaderSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedSubHeader"] = this.fixedSubHeader;
        data["subheaderStyle"] = this.subheaderStyle;
        data["subheaderSize"] = this.subheaderSize;
        data["titleStyle"] = this.titleStyle;
        data["containerStyle"] = this.containerStyle;
        data["subContainerStyle"] = this.subContainerStyle;
        return data;
    }
}

export interface IThemeSubHeaderSettingsDto {
    fixedSubHeader: boolean;
    subheaderStyle: string | undefined;
    subheaderSize: number;
    titleStyle: string | undefined;
    containerStyle: string | undefined;
    subContainerStyle: string | undefined;
}

export class TradeRecordDto implements ITradeRecordDto {
    order!: number;
    login!: number;
    symbol!: string | undefined;
    digits!: number;
    cmd!: number;
    volume!: number;
    openTime!: DateTime;
    state!: number;
    openPrice!: number;
    sl!: number;
    tp!: number;
    closeTime!: DateTime;
    gwVolume!: number;
    expiration!: DateTime;
    reason!: number;
    convRates!: number[] | undefined;
    commission!: number;
    commissionAgent!: number;
    storage!: number;
    closePrice!: number;
    profit!: number;
    taxes!: number;
    magic!: number;
    comment!: string | undefined;
    gwOrder!: number;
    activation!: number;
    gwOpenPrice!: number;
    gwClosePrice!: number;
    marginRate!: number;
    timestamp!: DateTime;
    apiData!: number[] | undefined;

    constructor(data?: ITradeRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.login = _data["login"];
            this.symbol = _data["symbol"];
            this.digits = _data["digits"];
            this.cmd = _data["cmd"];
            this.volume = _data["volume"];
            this.openTime = _data["openTime"] ? DateTime.fromISO(_data["openTime"].toString()) : <any>undefined;
            this.state = _data["state"];
            this.openPrice = _data["openPrice"];
            this.sl = _data["sl"];
            this.tp = _data["tp"];
            this.closeTime = _data["closeTime"] ? DateTime.fromISO(_data["closeTime"].toString()) : <any>undefined;
            this.gwVolume = _data["gwVolume"];
            this.expiration = _data["expiration"] ? DateTime.fromISO(_data["expiration"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            if (Array.isArray(_data["convRates"])) {
                this.convRates = [] as any;
                for (let item of _data["convRates"])
                    this.convRates!.push(item);
            }
            this.commission = _data["commission"];
            this.commissionAgent = _data["commissionAgent"];
            this.storage = _data["storage"];
            this.closePrice = _data["closePrice"];
            this.profit = _data["profit"];
            this.taxes = _data["taxes"];
            this.magic = _data["magic"];
            this.comment = _data["comment"];
            this.gwOrder = _data["gwOrder"];
            this.activation = _data["activation"];
            this.gwOpenPrice = _data["gwOpenPrice"];
            this.gwClosePrice = _data["gwClosePrice"];
            this.marginRate = _data["marginRate"];
            this.timestamp = _data["timestamp"] ? DateTime.fromISO(_data["timestamp"].toString()) : <any>undefined;
            if (Array.isArray(_data["apiData"])) {
                this.apiData = [] as any;
                for (let item of _data["apiData"])
                    this.apiData!.push(item);
            }
        }
    }

    static fromJS(data: any): TradeRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new TradeRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["login"] = this.login;
        data["symbol"] = this.symbol;
        data["digits"] = this.digits;
        data["cmd"] = this.cmd;
        data["volume"] = this.volume;
        data["openTime"] = this.openTime ? this.openTime.toString() : <any>undefined;
        data["state"] = this.state;
        data["openPrice"] = this.openPrice;
        data["sl"] = this.sl;
        data["tp"] = this.tp;
        data["closeTime"] = this.closeTime ? this.closeTime.toString() : <any>undefined;
        data["gwVolume"] = this.gwVolume;
        data["expiration"] = this.expiration ? this.expiration.toString() : <any>undefined;
        data["reason"] = this.reason;
        if (Array.isArray(this.convRates)) {
            data["convRates"] = [];
            for (let item of this.convRates)
                data["convRates"].push(item);
        }
        data["commission"] = this.commission;
        data["commissionAgent"] = this.commissionAgent;
        data["storage"] = this.storage;
        data["closePrice"] = this.closePrice;
        data["profit"] = this.profit;
        data["taxes"] = this.taxes;
        data["magic"] = this.magic;
        data["comment"] = this.comment;
        data["gwOrder"] = this.gwOrder;
        data["activation"] = this.activation;
        data["gwOpenPrice"] = this.gwOpenPrice;
        data["gwClosePrice"] = this.gwClosePrice;
        data["marginRate"] = this.marginRate;
        data["timestamp"] = this.timestamp ? this.timestamp.toString() : <any>undefined;
        if (Array.isArray(this.apiData)) {
            data["apiData"] = [];
            for (let item of this.apiData)
                data["apiData"].push(item);
        }
        return data;
    }
}

export interface ITradeRecordDto {
    order: number;
    login: number;
    symbol: string | undefined;
    digits: number;
    cmd: number;
    volume: number;
    openTime: DateTime;
    state: number;
    openPrice: number;
    sl: number;
    tp: number;
    closeTime: DateTime;
    gwVolume: number;
    expiration: DateTime;
    reason: number;
    convRates: number[] | undefined;
    commission: number;
    commissionAgent: number;
    storage: number;
    closePrice: number;
    profit: number;
    taxes: number;
    magic: number;
    comment: string | undefined;
    gwOrder: number;
    activation: number;
    gwOpenPrice: number;
    gwClosePrice: number;
    marginRate: number;
    timestamp: DateTime;
    apiData: number[] | undefined;
}

export class TradeTransactionDto implements ITradeTransactionDto {
    type!: number;
    cmd!: number;
    order!: number;
    orderBy!: number;
    symbol!: string | undefined;
    volume!: number;
    price!: number;
    sl!: number;
    tp!: number;
    ieDeviation!: number;
    comment!: string | undefined;
    expiration!: DateTime;
    crc!: number;
    tempID!: number;

    constructor(data?: ITradeTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.cmd = _data["cmd"];
            this.order = _data["order"];
            this.orderBy = _data["orderBy"];
            this.symbol = _data["symbol"];
            this.volume = _data["volume"];
            this.price = _data["price"];
            this.sl = _data["sl"];
            this.tp = _data["tp"];
            this.ieDeviation = _data["ieDeviation"];
            this.comment = _data["comment"];
            this.expiration = _data["expiration"] ? DateTime.fromISO(_data["expiration"].toString()) : <any>undefined;
            this.crc = _data["crc"];
            this.tempID = _data["tempID"];
        }
    }

    static fromJS(data: any): TradeTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TradeTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["cmd"] = this.cmd;
        data["order"] = this.order;
        data["orderBy"] = this.orderBy;
        data["symbol"] = this.symbol;
        data["volume"] = this.volume;
        data["price"] = this.price;
        data["sl"] = this.sl;
        data["tp"] = this.tp;
        data["ieDeviation"] = this.ieDeviation;
        data["comment"] = this.comment;
        data["expiration"] = this.expiration ? this.expiration.toString() : <any>undefined;
        data["crc"] = this.crc;
        data["tempID"] = this.tempID;
        return data;
    }
}

export interface ITradeTransactionDto {
    type: number;
    cmd: number;
    order: number;
    orderBy: number;
    symbol: string | undefined;
    volume: number;
    price: number;
    sl: number;
    tp: number;
    ieDeviation: number;
    comment: string | undefined;
    expiration: DateTime;
    crc: number;
    tempID: number;
}

export class TradingAccountInfoDto implements ITradingAccountInfoDto {
    balance!: number;
    credit!: number;
    equity!: number;
    margin!: number;
    marginFree!: number;
    marginLevel!: number;
    volume!: number;
    openOrdersInfo!: PositionDto[] | undefined;
    pendingOrdersInfo!: PendingOrderDto[] | undefined;

    constructor(data?: ITradingAccountInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.balance = _data["balance"];
            this.credit = _data["credit"];
            this.equity = _data["equity"];
            this.margin = _data["margin"];
            this.marginFree = _data["marginFree"];
            this.marginLevel = _data["marginLevel"];
            this.volume = _data["volume"];
            if (Array.isArray(_data["openOrdersInfo"])) {
                this.openOrdersInfo = [] as any;
                for (let item of _data["openOrdersInfo"])
                    this.openOrdersInfo!.push(PositionDto.fromJS(item));
            }
            if (Array.isArray(_data["pendingOrdersInfo"])) {
                this.pendingOrdersInfo = [] as any;
                for (let item of _data["pendingOrdersInfo"])
                    this.pendingOrdersInfo!.push(PendingOrderDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TradingAccountInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TradingAccountInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["balance"] = this.balance;
        data["credit"] = this.credit;
        data["equity"] = this.equity;
        data["margin"] = this.margin;
        data["marginFree"] = this.marginFree;
        data["marginLevel"] = this.marginLevel;
        data["volume"] = this.volume;
        if (Array.isArray(this.openOrdersInfo)) {
            data["openOrdersInfo"] = [];
            for (let item of this.openOrdersInfo)
                data["openOrdersInfo"].push(item.toJSON());
        }
        if (Array.isArray(this.pendingOrdersInfo)) {
            data["pendingOrdersInfo"] = [];
            for (let item of this.pendingOrdersInfo)
                data["pendingOrdersInfo"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITradingAccountInfoDto {
    balance: number;
    credit: number;
    equity: number;
    margin: number;
    marginFree: number;
    marginLevel: number;
    volume: number;
    openOrdersInfo: PositionDto[] | undefined;
    pendingOrdersInfo: PendingOrderDto[] | undefined;
}

export class TradingPlatformDto implements ITradingPlatformDto {
    serverType!: EnServerType;
    name!: string | undefined;
    code!: string | undefined;
    timeZone!: string | undefined;
    logins!: number[] | undefined;
    maxDemoAccountCountPerUser!: number;

    constructor(data?: ITradingPlatformDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serverType = _data["serverType"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.timeZone = _data["timeZone"];
            if (Array.isArray(_data["logins"])) {
                this.logins = [] as any;
                for (let item of _data["logins"])
                    this.logins!.push(item);
            }
            this.maxDemoAccountCountPerUser = _data["maxDemoAccountCountPerUser"];
        }
    }

    static fromJS(data: any): TradingPlatformDto {
        data = typeof data === 'object' ? data : {};
        let result = new TradingPlatformDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverType"] = this.serverType;
        data["name"] = this.name;
        data["code"] = this.code;
        data["timeZone"] = this.timeZone;
        if (Array.isArray(this.logins)) {
            data["logins"] = [];
            for (let item of this.logins)
                data["logins"].push(item);
        }
        data["maxDemoAccountCountPerUser"] = this.maxDemoAccountCountPerUser;
        return data;
    }
}

export interface ITradingPlatformDto {
    serverType: EnServerType;
    name: string | undefined;
    code: string | undefined;
    timeZone: string | undefined;
    logins: number[] | undefined;
    maxDemoAccountCountPerUser: number;
}

export class UiCustomizationSettingsDto implements IUiCustomizationSettingsDto {
    baseSettings!: ThemeSettingsDto;
    isLeftMenuUsed!: boolean;
    isTopMenuUsed!: boolean;
    isTabMenuUsed!: boolean;
    allowMenuScroll!: boolean;

    constructor(data?: IUiCustomizationSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseSettings = _data["baseSettings"] ? ThemeSettingsDto.fromJS(_data["baseSettings"]) : <any>undefined;
            this.isLeftMenuUsed = _data["isLeftMenuUsed"];
            this.isTopMenuUsed = _data["isTopMenuUsed"];
            this.isTabMenuUsed = _data["isTabMenuUsed"];
            this.allowMenuScroll = _data["allowMenuScroll"];
        }
    }

    static fromJS(data: any): UiCustomizationSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UiCustomizationSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseSettings"] = this.baseSettings ? this.baseSettings.toJSON() : <any>undefined;
        data["isLeftMenuUsed"] = this.isLeftMenuUsed;
        data["isTopMenuUsed"] = this.isTopMenuUsed;
        data["isTabMenuUsed"] = this.isTabMenuUsed;
        data["allowMenuScroll"] = this.allowMenuScroll;
        return data;
    }
}

export interface IUiCustomizationSettingsDto {
    baseSettings: ThemeSettingsDto;
    isLeftMenuUsed: boolean;
    isTopMenuUsed: boolean;
    isTabMenuUsed: boolean;
    allowMenuScroll: boolean;
}

export class UpdateUserSignInTokenOutput implements IUpdateUserSignInTokenOutput {
    signInToken!: string | undefined;
    encodedUserId!: string | undefined;
    encodedTenantId!: string | undefined;

    constructor(data?: IUpdateUserSignInTokenOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signInToken = _data["signInToken"];
            this.encodedUserId = _data["encodedUserId"];
            this.encodedTenantId = _data["encodedTenantId"];
        }
    }

    static fromJS(data: any): UpdateUserSignInTokenOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserSignInTokenOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signInToken"] = this.signInToken;
        data["encodedUserId"] = this.encodedUserId;
        data["encodedTenantId"] = this.encodedTenantId;
        return data;
    }
}

export interface IUpdateUserSignInTokenOutput {
    signInToken: string | undefined;
    encodedUserId: string | undefined;
    encodedTenantId: string | undefined;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    profilePictureId!: string | undefined;
    allowTradingPlatformOperations!: boolean;
    id!: number;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.profilePictureId = _data["profilePictureId"];
            this.allowTradingPlatformOperations = _data["allowTradingPlatformOperations"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["allowTradingPlatformOperations"] = this.allowTradingPlatformOperations;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    allowTradingPlatformOperations: boolean;
    id: number;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}